import {getMockups} from "../../thunk";

const getRequestId = (action) => action?.meta?.arg?.requestId || null;
const isLatestRequest = (state, requestId) => {
    if (!state.latestRequestId) {
        return true;
    }
    if (!requestId) {
        return false;
    }
    return state.latestRequestId === requestId;
};

export default {
    [getMockups.pending as any]: (state, action) => {
        state.status = 'loading';
        state.error = null;
        state.latestRequestId = getRequestId(action);
    },
    [getMockups.fulfilled as any]: (state, action) => {
        const requestId = getRequestId(action);
        if (!isLatestRequest(state, requestId)) {
            return;
        }
        state.status = 'resolved';
        state.data = action.payload.result;
        state.queryParams = {...action.meta.arg, page: +action.payload.page, limit: +action.payload.perPage, total: +action.payload.totalCount};
    },
    [getMockups.rejected as any]: (state, action) => {
        const requestId = getRequestId(action);
        if (!isLatestRequest(state, requestId)) {
            return;
        }
        state.status = 'rejected';
        state.error = action.payload;
    }
}
